import { yupResolver } from '@hookform/resolvers/yup';
import React, { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';
import * as yup from 'yup';

import { usePrepaidOtpVerifyMutation } from '@/app/api/prepaid';
import { getMobilePhone, setApplicationUuid } from '@/app/store/slices/app';
import { setAuth } from '@/app/store/slices/auth';
import { setCustomError } from '@/app/store/slices/error';

import { StepContentWrapper, Title } from '../../components';
import OtpVerify from '../../views/common-otp-verify';
const schema = yup.object({
  code: yup.string().min(4, 'Код должен состоять из 4 цифр').required()
});
const PrepaidVerifyPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mobile = useSelector(getMobilePhone);

  const [fetchVerify, { isLoading, data, isSuccess, error }] = usePrepaidOtpVerifyMutation();

  const err = error?.data?.error;

  const {
    control,
    handleSubmit,
    setError,
    watch,
    formState: { isValid, isDirty }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: { code: '' }
  });

  useEffect(() => {
    if (String(err?.code).toLowerCase() === 'resident') {
      dispatch(setCustomError(err));
    }
    if (String(err?.code).toLowerCase() === 'invalid_otp') {
      setError('code', { message: err.description });
    }
    if (String(err?.code).toLowerCase() === 'invalid_data') {
      if (err?.description?.mobile_phone) {
        setError('code', { message: err.description?.mobile_phone });
      }
    }
    if (String(err?.code).toLowerCase() === 'limit_card_error') {
      dispatch(setCustomError(err));
    }
  }, [err, navigate, setError, dispatch]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setAuth(data?.data));
      dispatch(setApplicationUuid(data?.data?.application_uuid));
    }
  }, [isSuccess, data, dispatch, navigate]);

  const handleVerify = async data => {
    let otp = data;
    if (data.code) {
      otp = data.code;
    }
    fetchVerify({ mobile_phone: mobile, code: otp });
  };

  const resendOtp = useCallback(() => {
    navigate('/prepaid-card/apply');
  }, []);

  const changeNumber = () => {
    navigate(-1);
  };
  useEffect(() => {
    isValid && handleVerify(watch('code'));
  }, [isValid]);

  return (
    <StepContentWrapper twStyles={tw`text-center`}>
      <div tw='max-w-[416px] mx-auto mb-[48px]'>
        <Title text='Введите код' variant='bold' twStyle={tw`mt-[30px] sm:mt-[48px] `} />
        <OtpVerify
          control={control}
          isValid={(isDirty && isValid) || isSuccess}
          loading={isLoading}
          phone={mobile}
          handleSubmit={handleSubmit}
          handleVerify={handleVerify}
          resendOtp={resendOtp}
          showChangePhone={true}
          changeNumber={changeNumber}
          timerVariant='otp-verify'
          initialMinutes={1}
          initialSeconds={59}
        />
      </div>
    </StepContentWrapper>
  );
};

export default PrepaidVerifyPage;
